import React, { Component } from 'react'
import { List, Radio, Flex, NavBar } from 'antd-mobile'
import send from '../../../utils/send_init'
import { ROOT_PATH } from '../../../config'
let page = 1;
class SwineList extends Component {
  constructor(props) {
    super(props);
    // 用于交互数据
    this.state = {
      refreshing: false,
      down: false,
      // 导航高度: 45, 搜索高度: 44, 子项名: 45
      height: window.HEIGHT - 78,
      modalData: [],
      sumCount: 0
    }
  }
  getData = () => {
    const { sex } = this.props;
    send({
      url: `${ROOT_PATH}/api/ifarm/v1/genealogy/breeder?sex=${sex}`,
      method: 'GET'
    })
      .then(res => {
        console.log(res.data);
        this.setState({
          modalData: res.data
        })
      })
      .catch(err => {
        console.log(err)
      })
  };
  getNextPageData = () => {
    console.log(this.state.sumCount, this.state.modalData.length);
    if (this.state.sumCount >= this.state.modalData.length) {
      page++;
      this.getData(page);
      this.setState({
        refreshing: true
      })
    }
  };
  componentDidMount() {
    if (this.state.modalData.length === 0) {
      page = 1;
      this.getData(1)
    }
  }
  render() {
    const { id, current } = this.props;
    return (
      <React.Fragment>
        <NavBar mode="light">品种列表</NavBar>
        <List
          renderHeader={() => (
            <Flex>
              <Flex.Item>品种编码</Flex.Item>
              <Flex.Item>品种描述</Flex.Item>
            </Flex>
          )}
        >
          <div
            style={{
              height: this.state.height,
              overflow: 'auto'
            }}
          >
            {this.state.modalData.map((item, index) => (
              <Radio.RadioItem
                key={index}
                checked={current === item.breeder}
                onClick={() => {
                  this.props.selectItem(item, id)
                }}
              >
                <Flex>
                  <Flex.Item>{item['breeder']}</Flex.Item>
                  <Flex.Item>{item.descLoc}</Flex.Item>
                </Flex>
              </Radio.RadioItem>
            ))}
          </div>
        </List>
      </React.Fragment>
    )
  }
}
export default SwineList
